@if (visible()) {
  <div>
    <nz-row [id]="table.tableCode" [nzGutter]="[16, 16]">
      @for (record of visibleRecords(); track record.recordId) {
        <nz-col
          [nzXs]="colSpan.xs"
          [nzSm]="colSpan.sm"
          [nzMd]="colSpan.md"
          [nzLg]="colSpan.lg"
          [nzXl]="colSpan.xl"
          [nzXXl]="colSpan.xxl"
        >
          <div class="simulationCard">
            <div class="simulationCardContent">
              <div class="simulationItemTitle">
                {{ record?.recordData?.simulationItemTitle }}
              </div>
              <div class="simulationItemMain">
                @if (!Array.isArray(record?.recordData?.simulationItemMain)) {
                  {{ record?.recordData?.simulationItemMain }}
                }
                @if (Array.isArray(record?.recordData?.simulationItemMain)) {
                  @for (itemText of record?.recordData?.simulationItemMain; track $index) {
                    <div>
                      {{ itemText }}
                    </div>
                  }
                }
              </div>
              <div class="simulationItemFooter">
                {{ record?.recordData?.simulationItemFooter }}
              </div>
            </div>
          </div>
        </nz-col>
      }
    </nz-row>
  </div>
}
